<mat-card fxLayoutGap class="p-3 d-flex gap-3">
  <div class="fw-semibold fs-4">{{agreementId?'Modifica Contratto':'Nuovo Contratto'}}</div>
  <form [formGroup]="formGroup" class="d-flex flex-column gap-3">
    <div class="w-100 row m-0 p-0 gap-3">
      <div class="col m-0 p-0">
        <app-dea-label class="mb-2" [label]="'Tipo:'"></app-dea-label>
        <mat-radio-group formControlName="type" class="d-flex flex-row gap-4 align-items-start" color="primary">
          <mat-radio-button *ngFor="let type of (_agreementTypes$ | async);" [value]="type"
            class="text-capitalize text-nowrap">
            {{type.toLowerCase()}}
          </mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="col m-0 p-0 d-flex gap-1">
      </div>
    </div>
    <div class="w-100 d-flex flex-row gap-3">
      <div class="flex-grow-1">
        <app-dea-label class="mb-2" [label]="'Codice interno contratto: (Opzionale)'"></app-dea-label>
        <input formControlName="code" type="text" class="form-control dea-form-input" />
      </div>
    </div>
    <div class="w-100 d-flex flex-row gap-3">
      <div class="flex-grow-1">
        <app-dea-label class="mb-2" [label]="'Inizio: (Opzionale)'"></app-dea-label>
        <input formControlName="start" type="date" class="form-control dea-form-input" />
      </div>
      <div class="flex-grow-1">
        <app-dea-label class="mb-2" [label]="'Fine: (Opzionale)'"></app-dea-label>
        <input formControlName="end" type="date" class="form-control dea-form-input" />
      </div>
    </div>
    <div class="w-100 d-flex flex-row gap-3">
      <div class="flex-grow-1">
        <app-dea-label class="mb-2" [label]="'Ore: (Opzionale)'"></app-dea-label>
        <input formControlName="hours" type="number" class="form-control dea-form-input" justNumber />
      </div>
      <div class="flex-grow-1">
        <app-dea-label class="mb-2" [label]="'RAL:'"></app-dea-label>
        <input formControlName="ral" type="number" class="form-control dea-form-input" justNumber />
      </div>
    </div>
    <div class="w-100 d-flex flex-row gap-3">
      <div class="flex-grow-1">
        <app-dea-label class="mb-2" [label]="'Lordo Mensile:'"></app-dea-label>
        <div class="input-group">
          <input formControlName="monthly_gross" type="text" class="form-control dea-form-input" justNumber />
          <span class="input-group-text">€</span>
        </div>
      </div>
      <div class="flex-grow-1">
        <app-dea-label class="mb-2" [label]="'Netto Mensile:'"></app-dea-label>
        <div class="input-group">
          <input formControlName="monthly_net" type="text" class="form-control dea-form-input" justNumber />
          <span class="input-group-text">€</span>
        </div>
      </div>
    </div>
    <div class="w-100">
      <app-dea-label [label]="'Allegato: (Opzionale)'"></app-dea-label>
      <div>
        <input type="file" accept="image/png,image/jpeg,.pdf" class="form-control dea-form-input mb-1"
          placeholder="Seleziona un file" (change)="onFileChange($event)" />
        <div class="fw-lighter fs-055r">Formati accettati: PDF - PNG/JPG/JPEG</div>
      </div>
    </div>
    <div class="w-100">
      <app-dea-label class="mb-2" [label]="'Descrizione: (Opzionale)'"></app-dea-label>
      <textarea formControlName="description" class="form-control dea-form-input" rows="2"
        style="max-height: 80px !important;">
      </textarea>
    </div>
  </form>
  <div *ngIf="error" class="fs-075r text-danger">{{error.message}}</div>
  <div class="m-0 p-0 gap-2" mat-dialog-actions align="end">
    <button class="px-5 py-1" mat-stroked-button (click)="onDismiss()">Annulla</button>
    <button *ngIf="!isPosting" class="px-5 py-1" mat-flat-button color="primary" (click)="onConfirm()">
      Salva
    </button>
    <button *ngIf="isPosting" class="px-5 py-1" mat-flat-button disabled>
      <mat-icon><mat-spinner diameter="18"></mat-spinner></mat-icon> Caricamento
    </button>
  </div>
</mat-card>